export const dataCyName = (name: string[]) =>
  name.join('-').toLowerCase().replaceAll('_', '-').replaceAll(' ', '-'); // Lower case the name and replace all underscores and spaces with dashes

export default dataCyName;
